import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import React from 'react'
import PropTypes from 'prop-types'
import PaymentCard from './PaymentCard'

export default function PaymentDetailsDialog({ open, bookingId, paymentDetails, loading, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm'>
      <DialogTitle sx={{ mr: 5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Détails de paiement
          <IconButton onClick={onClose} size='small'>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Typography color='text.secondary'>Chargement...</Typography>
        ) : (
          <PaymentCard booking={bookingId} paymentDetails={paymentDetails} />
        )}
      </DialogContent>
    </Dialog>
  )
}

PaymentDetailsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  bookingId: PropTypes.string.isRequired,
  paymentDetails: PropTypes.any,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired
}
